import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flexRow pb-5" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "control-label" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "control-label" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-8" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "control-label" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "control-label" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "control-label" }
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "control-label" }
const _hoisted_27 = { class: "ml-2" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "control-label" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "control-label" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "control-label" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "control-label" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["value"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = { class: "control-label" }
const _hoisted_51 = {
  key: 1,
  class: "form-group"
}
const _hoisted_52 = { class: "control-label" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_54 = { class: "fs-22" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = { class: "ml-2" }
const _hoisted_58 = { class: "form-group mt-4" }
const _hoisted_59 = {
  key: 0,
  class: "ml-2 text-success"
}
const _hoisted_60 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_62 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_preziario = _resolveComponent("preziario")!
  const _component_accordion = _resolveComponent("accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary float-right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Salva",
          text: "Salva"
        })
      ]),
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Dettaglio Offerta",
          text: "Dettaglio Offerta"
        })
      ]),
      _hoisted_3,
      (_ctx.offer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nome",
                  text: "Nome"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.offer.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.offer.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Sottotitolo",
                  text: "Sottotitolo"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.offer.subTitle) = $event))
              }, null, 512), [
                [_vModelText, _ctx.offer.subTitle]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Id InAppPurchase Apple (lasciare vuoto se non c'è un prodotto collegato)",
                  text: "Id InAppPurchase Apple (lasciare vuoto se non c'è un prodotto collegato)"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.offer.appleIapId) = $event))
              }, null, 512), [
                [_vModelText, _ctx.offer.appleIapId]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Url immagine",
                      text: "Url immagine"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.offer.imgUrl) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.offer.imgUrl]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: _ctx.offer.imgUrl,
                  class: "preview",
                  style: {"max-height":"100px"}
                }, null, 8, _hoisted_16)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Display Order",
                  text: "Display Order"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "number",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.offer.displayOrder) = $event))
              }, null, 512), [
                [_vModelText, _ctx.offer.displayOrder]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Categoria",
                  text: "Categoria"
                })
              ]),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.offer.shopCategoryIdentifier) = $event)),
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getCategory && _ctx.getCategory(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopCategories, (item, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: item.identifier
                  }, _toDisplayString(item.name), 9, _hoisted_21))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.offer.shopCategoryIdentifier]
              ])
            ]),
            _hoisted_22,
            (_ctx.shopCategorySelected)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Configura requirements dell'offerta",
                            text: "Configura requirements dell'offerta"
                          })
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openRequirementsModal && _ctx.openRequirementsModal(...args)))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Apri requirements",
                              text: "Apri requirements"
                            })
                          ]),
                          _createElementVNode("span", _hoisted_27, [
                            _createTextVNode(_toDisplayString(_ctx.offer.requirements.length) + " ", 1),
                            _createVNode(_component_localized_text, {
                              localizedKey: "inseriti",
                              text: "inseriti"
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("label", _hoisted_31, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "MinProductLevelRequired (livello minimo per poter vedere l'offerta)",
                            text: "MinProductLevelRequired (livello minimo per poter vedere l'offerta)"
                          })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.offer.minProductLevelRequired) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.offer.minProductLevelRequired]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "MaxProductLevelRequired (livello massimo per poter vedere l'offerta)",
                            text: "MaxProductLevelRequired (livello massimo per poter vedere l'offerta)"
                          })
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          type: "number",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.offer.maxProductLevelRequired) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.offer.maxProductLevelRequired]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("label", _hoisted_38, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Filtro per nazione (se nessuna selezionata, visibile a tutti)",
                            text: "Filtro per nazione (se nessuna selezionata, visibile a tutti)"
                          })
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.nazioneFilter, (item, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: item }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-danger",
                              onClick: ($event: any) => (_ctx.removeNazione(item, i))
                            }, "x", 8, _hoisted_39),
                            _createTextVNode(" " + _toDisplayString(item), 1)
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tempNazione) = $event)),
                          onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.selectNazione && _ctx.selectNazione(...args))),
                          disabled: _ctx.filteredNaziones.length == 0
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNaziones, (nazione, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: i,
                              value: nazione
                            }, _toDisplayString(nazione.name), 9, _hoisted_41))
                          }), 128))
                        ], 40, _hoisted_40), [
                          [_vModelSelect, _ctx.tempNazione]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("label", _hoisted_44, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Filtro per ruolo (se nessuno selezionato, visibile a tutti)",
                            text: "Filtro per ruolo (se nessuno selezionato, visibile a tutti)"
                          })
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.rolesFilter, (item, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: item }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-danger",
                              onClick: ($event: any) => (_ctx.removeRole(item, i))
                            }, "x", 8, _hoisted_45),
                            _createTextVNode(" " + _toDisplayString(item), 1)
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tempRole) = $event)),
                          onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.selectRole && _ctx.selectRole(...args))),
                          disabled: _ctx.filteredRoles.length == 0
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRoles, (role, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: i,
                              value: role
                            }, _toDisplayString(role), 9, _hoisted_47))
                          }), 128))
                        ], 40, _hoisted_46), [
                          [_vModelSelect, _ctx.tempRole]
                        ])
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("label", _hoisted_50, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Applica product level (lasciare a false per non modificarlo)",
                  text: "Applica product level (lasciare a false per non modificarlo)"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control checkBig",
                type: "checkbox",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.offer.applyProductLevel) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.offer.applyProductLevel]
              ])
            ]),
            (_ctx.offer.applyProductLevel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "ProductLevel Applied",
                      text: "ProductLevel Applied"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "number",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.offer.productLevelApplied) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.offer.productLevelApplied]
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_53,
            _createVNode(_component_accordion, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Prezziario",
                    text: "Prezziario"
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_preziario, {
                  modelValue: _ctx.offer.preziario,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.offer.preziario) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Prodotti nell'offerta",
                  text: "Prodotti nell'offerta"
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.openProductsModal && _ctx.openProductsModal(...args)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Apri",
                    text: "Apri"
                  })
                ]),
                _createElementVNode("span", _hoisted_57, [
                  _createTextVNode(_toDisplayString(_ctx.offer.products.length) + " ", 1),
                  _createVNode(_component_localized_text, {
                    localizedKey: "inseriti",
                    text: "inseriti"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Offerta di upsell",
                  text: "Offerta di upsell"
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.openUpsellModal && _ctx.openUpsellModal(...args)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Apri",
                    text: "Apri"
                  })
                ]),
                (_ctx.offer.upsellOffers.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                      _createElementVNode("b", null, [
                        _createTextVNode(_toDisplayString(_ctx.offer.upsellOffers.length) + " ", 1),
                        _createVNode(_component_localized_text, {
                          localizedKey: "selezionate",
                          text: "selezionate"
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_60, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Nessuna",
                        text: "Nessuna"
                      })
                    ]))
              ])
            ]),
            _hoisted_61,
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Salva",
                  text: "Salva"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}